<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ typeName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="资产维度" prop="category">
              <template>
                <el-radio-group :disabled="!editMode" v-model="form.category" @change="categoryChange">
                  <el-radio v-for="item in AssetTypeOptions" :key="item.id" :disabled="!editMode" :label="item.id">
                    {{ item.name }}
                  </el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="盘点方式" prop="stocktakingModeId">
              <template>
                <el-select :disabled="!editMode" v-model="form.stocktakingModeId" style="width: 90%" filterable placeholder="请选择盘点方式" @change="stocktakingModeChange">
                  <el-option v-for="item in stocktakingModeOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="盘点范围" prop="stocktakingRange">
              <template>
                <el-row v-for="item in InventoryRangeOptions" :key="item.id">
                  <el-col :span="6" v-if="!(form.category == 0 && item.id == 1)">
                    <el-radio-group :disabled="!editMode" v-model="form.stocktakingRange" @change="stocktakingRangeChange">
                      <el-radio :disabled="!editMode" :label="item.id">
                        {{ item.name }}
                      </el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="deptName" v-if="form.stocktakingRange == 1">
              <el-select :disabled="!editMode" v-model="form.deptName" style="width: 90%" filterable placeholder="请选择盘点详情" :filter-method="getDepts" @change="deptChange">
                <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="stocktakingRange" v-else-if="form.stocktakingRange == 2">
              <template>
                <SelectTree :disabled="!editMode" @handleCheckChange="handleCheckChange" :filterable="true" :filterMethod="getAssetTrees" :defaultProps="defaultProps" :placeholder="'请选择盘点详情'" :data="STATIC_FixedAssetTrees" :defaultValue="form.depstocktakingModeIdtName" style="width: 90%;"></SelectTree>
              </template>
            </el-form-item>
            <el-form-item prop="warehouseName" v-else>
              <template>
                <el-select :disabled="!editMode" v-model="form.warehouseName" style="width: 90%" filterable placeholder="请选择盘点详情" :filter-method="getWarehouses" @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="form.category != 0">
          <el-col :span="6">
            <el-form-item prop="stocktakingCategory">
              <template>
                <el-radio-group :disabled="!editMode" v-model="form.stocktakingCategory" @change="stocktakingCategoryChange">
                  <el-radio v-for="item in stocktakingCategoryOptions" :key="item.id" :disabled="!editMode" :label="item.id">
                    {{ item.name }}
                  </el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">盘点基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="盘点单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成盘点单号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点人" prop="userName">
                <el-select :disabled="!editMode" v-model="form.userName" style="width: 90%" filterable placeholder="请选择盘点人" :filter-method="getUsers" @change="userChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点日期" prop="date">
                <el-date-picker :disabled="!editMode" v-model="form.date" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="系统默认为当前日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <AssetInfoEdit ref="AssetInfoEditRef" :isInventory="true" :details="form.details" :canEdit="editMode" :typeName="typeName" :ParentForm="form" :FixedAssetParam="fixedAssetParam" @autoTotalAmount="autoTotalAmount" :isRepeatMethod="isRepeatMethod" isRepeatMsg="当前盘点信息已存在，请去子表编辑！" />

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetDeptClaimById,
  GetDeptInStockById,
  SaveInventory,
  RejectDeptInStock,
  GetFixedAssetStockInfos,
  GetInventoryById,
  GetWarehouseOutStocks,
  GetDictionarys,
} from "@/api";
import {
  AssetTypeOptions,
  InventoryRangeOptions,
  stocktakingCategoryOptions,
} from "@/enum";
import SelectTable from "@/components/select-table";
import SelectTree from "@/components/select-tree";
import ApproveInfo from "@/components/approve-info";
import AssetInfoEdit from "@/components/asset-into-edit";
export default {
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    SelectTree,
    AssetInfoEdit,
  },
  /** 定义属性 */
  data () {
    return {
      typeName: "盘点",
      form: {},
      rules: {
        category: [
          { required: true, message: "资产维度不能为空", trigger: "blur" },
        ],
        stocktakingModeId: [
          { required: true, message: "盘点方式不能为空", trigger: "blur" },
        ],
        stocktakingRange: [
          { required: true, message: "盘点范围不能为空", trigger: "blur" },
        ],
        warehouseName: [
          { required: true, message: "盘点详情不能为空", trigger: "blur" },
        ],
        stocktakingRange: [
          { required: true, message: "盘点详情不能为空", trigger: "blur" },
        ],
        deptName: [
          { required: true, message: "盘点详情不能为空", trigger: "blur" },
        ],
        stocktakingCategory: [
          { required: true, message: "盘点资产类型不能为空", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "盘点人不能为空", trigger: "blur" },
        ],
        date: [
          { required: true, message: "盘点日期不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectDeptInStock,

      AssetTypeOptions: AssetTypeOptions,
      InventoryRangeOptions: InventoryRangeOptions,
      stocktakingCategoryOptions: stocktakingCategoryOptions,
      stocktakingModeOptions: [],

      defaultProps: {
        children: "children",
        label: "name",
      },

      // 子表
      childForm: {},
      childFormRules: {
        fixedAssetNo: [
          { required: true, message: "资产编号不能为空", trigger: "blur" },
        ],
        number: [{ required: true, message: "数量不能为空", trigger: "blur" }],
      },
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      openSubformModal: false,
      fixedAssetParam: {
        deptId: null,
        warehouseId: null,
        assetTypeId: null,
        stocktakingCategory: null,
      },
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      GetDictionarys({
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        type: 13,
      }).then((res) => {
        this.stocktakingModeOptions = res.returnData.data;
      });
      var query = this.$route.query;
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetInventoryById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        if (!this.form.details) {
          this.form.details = [];
        }
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
        this.initWorkFlowProperty(this.form);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
      });
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        category: 1,
        stocktakingModeId: null,
        stocktakingModeName: null,
        stocktakingRange: null,
        stocktakingRangeName: null,
        warehouseId: null,
        warehouseName: null,
        stocktakingRange: 0,
        stocktakingRangeName: "按科室",
        deptId: null,
        deptName: null,
        stocktakingCategory: 0,
        stocktakingCategoryName: "全部资产",
        userId: this.userInfo.id,
        userName: this.userInfo.name,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        remark: null,
        toTalNumber: null,
        totalAmount: null,
        createdUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
        details: [],
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 保存
    submit () {
      this.form.details = this.$refs.AssetInfoEditRef.getDetails();
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveInventory(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        });
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    /**
     * 刷新资产详情
     */
    RefenceAccesst () {
      if (
        this.form.category != null &&
        this.form.stocktakingModeId != null &&
        this.form.stocktakingRange != null &&
        this.form.stocktakingCategory != null
      ) {
        if (
          (this.form.stocktakingRange == 1 && this.form.deptName != null) ||
          (this.form.stocktakingRange == 2 &&
            this.form.depstocktakingModeIdtName != null) ||
          (this.form.stocktakingRange == 0 && this.form.warehouseName != null)
        ) {
          window.setTimeout(() => {
            this.$refs.AssetInfoEditRef.getFixedAssetList("").then((res) => {
              this.form.details = res;
              this.form.details.forEach((e, index) => {
                e.$index = index + 1;
                e.inventoryNumber = e.number;
                e.diffNumber = e.inventoryNumber - e.number;
                e.diffAmount = e.diffNumber * e.price;
                if (e.number < e.inventoryNumber) {
                  //盘盈
                  e.result = "盘盈";
                } else if (e.number == e.inventoryNumber) {
                  //正常e
                  e.result = "正常";
                } else {
                  //盘亏
                  e.result = "盘亏";
                }
              });

              this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
            });
          }, 200);
        } else {
          this.form.details = [];
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });

          this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
        }
      } else {
        this.form.details = [];
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
      }
    },
    /**
     * 资产维度选择
     */
    categoryChange (val) {
      this.getAssetTrees();

      this.form.stocktakingModeId = null;
      this.form.stocktakingRange = 0;
      this.form.deptId = null;
      this.form.deptName = null;
      this.form.warehouseId = null;
      this.form.warehouseName = null;
      this.form.warehouseManagerId = null;
      this.form.warehouseManagerName = null;
      this.form.assetTypeId = null;
      this.form.assetTypeName = null;
      this.form.stocktakingCategory = 0;
      this.RefenceAccesst();
    },
    /**
     * 盘点方式选择
     */
    stocktakingModeChange (val) {
      this.form.stocktakingRange = 0;
      this.form.deptId = null;
      this.form.deptName = null;
      this.form.warehouseId = null;
      this.form.warehouseName = null;
      this.form.warehouseManagerId = null;
      this.form.warehouseManagerName = null;
      this.form.assetTypeId = null;
      this.form.assetTypeName = null;
      this.form.stocktakingCategory = 0;
      this.RefenceAccesst();
    },
    /**
     * 盘点范围改变
     */
    stocktakingRangeChange (val) {
      this.form.deptId = null;
      this.form.deptName = null;
      this.form.warehouseId = null;
      this.form.warehouseName = null;
      this.form.warehouseManagerId = null;
      this.form.warehouseManagerName = null;
      this.form.assetTypeId = null;
      this.form.assetTypeName = null;
      this.form.stocktakingCategory = 0;

      this.RefenceAccesst();
    },
    /**
     * 建卡资产选择
     */
    stocktakingCategoryChange (val) {
      this.fixedAssetParam = {
        deptId: this.form.deptId,
        warehouseId: this.form.warehouseId,
        assetTypeId: this.form.assetTypeId,
        stocktakingCategory: this.form.stocktakingCategory,
      };
      this.RefenceAccesst();
    },
    /**
     * 库房选择
     */
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
      }
      this.fixedAssetParam = {
        deptId: null,
        warehouseId: this.form.warehouseId,
        assetTypeId: null,
        stocktakingCategory: this.form.stocktakingCategory,
      };
      this.RefenceAccesst();
    },
    /**
     * 科室选择
     */
    deptChange (val) {
      this.form.deptId = val;
      this.fixedAssetParam = {
        deptId: this.form.deptId,
        warehouseId: null,
        assetTypeId: null,
        stocktakingCategory: this.form.stocktakingCategory,
      };
      this.RefenceAccesst();
    },
    /**
     * 资产类型选择
     */
    handleCheckChange (node) {
      if (node) {
        this.form.assetTypeId = node.id;
        this.form.assetTypeName = node.name;
      } else {
        this.form.assetTypeId = "";
        this.form.assetTypeName = "";
      }
      this.fixedAssetParam = {
        deptId: null,
        warehouseId: null,
        assetTypeId: this.form.assetTypeId,
        stocktakingCategory: this.form.stocktakingCategory,
      };
      this.RefenceAccesst();
    },
    /**
     * 盘点人选择
     */
    userChange (val) {
      this.form.userId = val;
    },
    autoTotalAmount (e) {
      let toTalNumber = 0;
      let totalAmount = 0;
      this.form.details = e;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        toTalNumber = toTalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.toTalNumber = toTalNumber;
      this.form.totalAmount = totalAmount;
    },
    isRepeatMethod (arr, row) {
      let item = arr.find(
        (e) =>
          e.$index != row.$index &&
          e.assetId == row.assetId &&
          e.price == row.price &&
          e.locationName == row.locationName &&
          e.assetSource == row.assetSource &&
          e.packDesc == row.packDesc &&
          e.manufacturerId == row.manufacturerId &&
          e.certId == row.certId &&
          e.brandId == row.brandId &&
          e.warehouseId == row.warehouseId &&
          e.deptId == row.deptId
      );
      if (item) {
        return true;
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.$refs.AssetInfoEditRef.getFixedAssetList();
    this.getAssetTrees();
    this.getDepts();
    this.getUsers();
    this.getWarehouses();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
